module.exports = __webpack_public_path__ + "static/media/icon-ir-pensao-alimenticia.dfe614b4.svg";